import {
  Box,
  Flex,
  Grid,
  HStack,
  Image,
  Stack,
  Table,
  Text,
} from "@chakra-ui/react";
import React from "react";
import AppointButton from "../components/custom/AppointButton";
import { FilledButton, SimpleOutlineButton } from "../components/custom/Button";
import RichText from "../components/custom/RichText";
import Stats from "../components/custom/Stats";
import Steps from "../components/custom/Steps";
import { GiCheckMark } from "react-icons/gi";
import TestimonialSwiper from "../components/custom/TestimonialSwiper";
import TaxGrid from "../components/custom/TaxGrid";
import { useColorModeValue } from "../components/ui/color-mode";
import { Helmet } from "react-helmet-async";

const ExpertCAScreen = () => {
  const secondBg = useColorModeValue("#b8fff7", "#090110");

  const services = [
    {
      title: "CA-Assisted Income Tax Filing",
      description:
        "Get expert help to maximize deductions and minimize tax liability. Our CAs ensure accurate filings and timely submissions.",
      buttonText: "File with CA",
    },
    {
      title: "GST Filing & Compliance",
      description:
        "Let our CAs handle your GST returns, audits, and compliance, ensuring accuracy and helping you avoid penalties.",
      buttonText: "Start Filing",
      url: "/gst-filing"
    },
    {
      title: "Business Compliance Services",
      description:
        "Stay legally compliant with expert CA assistance. We manage ROC filings, annual returns, and regulatory requirements.",
      buttonText: "Ensure Compliance",
      url: "/business-registration"
    },
    {
      title: "Investment & Tax Planning",
      description:
        "Get personalized tax-saving strategies and investment planning from expert CAs to optimize your financial growth.",
      buttonText: "Plan with CA",
      url: "/itr-filing"
    },
    {
      title: "Financial Advisory Services",
      description:
        "Our CAs provide tailored financial guidance for businesses and individuals, helping you make informed decisions.",
      buttonText: "Get Expert Advice",
      url: "/contact"
    },
  ];

  const steps = [
    {
      label: "Share your tax or financial concerns",
      icon: "../assets/assistance/tax.png",
    },
    {
      label: "Get matched with a certified CA",
      icon: "../assets/assistance/ca.png",
    },
    {
      label: "Receive personalized advice via call or email",
      icon: "../assets/assistance/advice.png",
    },
    {
      label: "Get end-to-end filing & compliance support",
      icon: "../assets/assistance/compliance.png",
    },
  ];

  return (
    <>
      {/* Helmet */}
      <Helmet>
        <title>Expert CA Assistance - 360fintax</title>
        <meta
          name="description"
          content="Receive personalized tax and financial guidance from 360fintax's experts. Our team offers tailored solutions to address your unique financial needs."
        />
        <link
          rel="canonical"
          href="https://tax-services-web.vercel.app/expert-assistance"
        />
      </Helmet>

      {/* Hero Section */}
      <Stack
        bgColor={secondBg}
        gap={5}
        py="28"
        px={{ base: "5", md: "10", lg: "20" }}
        alignItems="center"
      >
        <RichText
          subtitle="360fintax"
          title="Expert CA Assistance "
          description="Get expert guidance on tax filing, business compliance, and financial planning—all from the comfort of your home."
          w={{ base: "100%", lg: "70%" }}
          pt={{ base: "10", md: "10" }}
        />
        <AppointButton text={<SimpleOutlineButton title="Register Now" />} />
        {/* <Image src="../assets/about.png" h="330px" /> */}
      </Stack>

      {/* Stats */}
      <Stats bgColor="none" />

      {/* Popular Services */}
      <Box py="10" data-aos="fade-up">
        <RichText title="CA-Assisted Services" colorText="Services" />
        <TaxGrid services={services} />
      </Box>


      {/* Steps */}
      <Box py="10" px={{ base: "5", md: "5", lg: "20" }}>
        <Steps
          title="How CA Assistance Works?"
          colorText="CA Assistance"
          buttonText="Book a Call Now"
          steps={steps}
        />
      </Box>

      {/* Testmonials */}
      <Stack
        data-aos="fade-up"
        textAlign="center"
        gap="10"
        py={{ base: "10", md: "10", lg: "10" }}
        alignItems="center"
      >
        <RichText
          title="Real Success Stories"
          colorText="Success"
          description="Discover how we've helped individuals and businesses stay compliant and stress-free, year after year."
          w={{ base: "xs", md: "3xl" }}
        />
        <TestimonialSwiper />
      </Stack>
    </>
  );
};

export default ExpertCAScreen;
